import request from '@/utils/request'
import type { AxiosResponse } from 'axios'
import type { ApiResponse } from './game'
export async function queryProse(): Promise<any> {
  return request('/prose')
}


export const getDomainInfo = (params): Promise<ApiResponse<any>> => {
  return request.get("/download/channel/config/index", params)
}

// 马甲包的情况下，需要前端上报充值和首充

export const getRechargeInfo = (params): Promise<ApiResponse<any>> => {
  return request.get("/download/recharge/info/list", params)
}
// 马甲包的情况下，需要前端上报充值确认
export const postRechargeConfirm = (params): Promise<ApiResponse<any>> => {
  return request.post("/download/recharge/info/confirm", params)
}
